<!--begin::Brand-->
<div class="brand flex-column-auto" id="kt_brand" [ngClass]="brandClasses">
  <!--begin::Logo-->
  <a routerLink="/" class="brand-logo">
    <img alt="Logo" [attr.src]="headerLogo" style="width: 110px; height: auto;" />
  </a>
  <!--end::Logo-->

  <ng-container *ngIf="asideSelfMinimizeToggle">
    <button class="brand-toggle btn btn-sm px-0" id="kt_aside_toggle">
      <span
        [inlineSVG]="
        './assets/media/svg/icons/Hamburger_icon_white.svg'
        "
        cacheSVG="true"
        class="svg-icon svg-icon-xl"
      ></span>
    </button>
  </ng-container>
</div>
<!--end::Brand-->

<!--begin::Aside Menu-->
<div class="aside-menu-wrapper flex-column-fluid" id="kt_aside_menu_wrapper" style="background-color: white !important; box-shadow: 10px 0 5px -5px #d1d1d1;">
  <ng-container *ngIf="disableAsideSelfDisplay">
    <!--begin::Header Logo-->
    <a routerLink="/">
      <img alt="Logo" [attr.src]="headerLogo" />
    </a>
    <!--end::Header Logo-->
  </ng-container>
  <!--begin::Menu Container-->
  <div
    id="kt_aside_menu"
    class="aside-menu"
    [ngClass]="asideMenuCSSClasses"
    data-menu-vertical="1"
    [attr.data-menu-scroll]="asideMenuScroll"
    [attr.data-menu-dropdown]="asideMenuDropdown"
    data-menu-dropdown-timeout="500"
    style="background-color: white !important; box-shadow: 10px 0 5px -3px #d1d1d1;"
  >
    <!-- begin::Menu Nav -->
    <ul class="menu-nav" [ngClass]="ulCSSClasses">
      <!-- begin::1 Level -->
      <li
        class="menu-item"
        aria-haspopup="true"
        routerLinkActive="menu-item-active"
      >
        <a class="menu-link" routerLink="/users" routerLinkActive="active">
          <span
            [inlineSVG]="'./assets/media/svg/icons/General/User.svg'"
            cacheSVG="true"
            class="svg-icon menu-icon"
          ></span>
          <span class="menu-text" style="font-weight:700 !important;">Usuarios</span>
        </a>
      </li>
      <!-- end::1 Level -->


    </ul>
    <!-- end::Menu Nav -->
  </div>
  <!--end::Menu Container-->
</div>
<!--end::Aside Menu-->
